{
  "version": 1,
  "asset_id": "4687b761-241e-4f50-b607-698ecf8b32cc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4687b761-241e-4f50-b607-698ecf8b32cc/reflux-stomach-before.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4687b761-241e-4f50-b607-698ecf8b32cc/reflux-stomach-before.png",
  "original_filename": "reflux-stomach-before.png",
  "size": 106450,
  "content_type": "image/png",
  "created_at": "2026-09-13T20:58:41Z"
}
